import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useNavigate, useParams } from 'react-router';
import { EmptyState } from '@/shared/ui';
import { QuoteDetailHeader, QuoteDetailPanel } from '@/widgets/quote-detail';

/**
 * 어드민 견적 상세(/quotes/:quoteRequestId) — 주소 해석과 "목록으로" 이동만 하고, 머리말(견적 번호·상태 배지)과 내용은 위젯이 그린다.
 * 올바르지 않은 주소는 머리말 아래 카드 안 가운데 안내로 알린다.
 */
export const QuoteDetailPage = (): ReactElement => {
  const navigate = useNavigate();
  const { quoteRequestId } = useParams<{ quoteRequestId: string }>();
  const parsed = normalizedUuidSchema.safeParse(quoteRequestId);
  const goToList = (): void => {
    void navigate('/quotes');
  };

  if (!parsed.success) {
    return (
      <>
        <QuoteDetailHeader quote={null} onBack={goToList} />
        <EmptyState isError>올바른 견적 주소가 아닙니다.</EmptyState>
      </>
    );
  }

  return <QuoteDetailPanel key={parsed.data} quoteRequestId={parsed.data} onBack={goToList} />;
};
